import React from "react";
import { Field } from "react-final-form";
import { Dropdown as SUIRDropdown } from "semantic-ui-react";
import styled from "styled-components";

import SubmissionPeriod from "src/types/SubmissionPeriod";
import { SubmissionPeriodType } from "src/types/enums/SubmissionPeriodType";
import { formatDate, formatSubmissionPeriodType } from "src/utils/format";
import Dropdown from "src/components/Form/Dropdown";

interface Props {
  submissionPeriods: SubmissionPeriod[];
  warningCount: number;
  selectedType: SubmissionPeriodType | "all";
  typeOptions: Array<{ key: string; value: string; text: string }>;
  onTypeChange: (type: SubmissionPeriodType | "all") => void;
}

export const FormContent: React.FC<Props> = ({
  submissionPeriods,
  warningCount,
  selectedType,
  typeOptions,
  onTypeChange,
}) => {
  const submissionPeriodOptions: Array<{
    key: number;
    text: string;
    value: number;
  }> = submissionPeriods.map((sp, index) => {
    const { name, dueDate, id, submissionType } = sp;
    return {
      key: index,
      text: `Name: ${name}, Type: ${formatSubmissionPeriodType(submissionType)}, Due Date: ${formatDate(dueDate)}`,
      value: id,
    };
  });

  const utilityWarningText =
    warningCount === 1 ? "this utility" : "these utilities";

  return (
    <div>
      <TypeDropdownContainer>
        <TypeDropdown
          placeholder="Select Type"
          selection
          options={typeOptions}
          value={selectedType}
          onChange={(_, data) => onTypeChange(data.value as SubmissionPeriodType | "all")}
        />
      </TypeDropdownContainer>
      <Field<number>
        wrapperStyling={{ margin: "0px" }}
        component={StyledDropdown}
        name="submissionPeriodId"
        options={submissionPeriodOptions}
      />
      <h4 style={{ marginTop: "20px", textAlign: "center" }}>
        {`Are you sure you want to assign the above submission period to ${utilityWarningText}?`}
      </h4>
    </div>
  );
};

const TypeDropdownContainer = styled.div`
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
`;

const TypeDropdown = styled(SUIRDropdown)`
  width: 100%;
  max-width: 550px;
  margin: 0 auto;
` as unknown as typeof SUIRDropdown;

const StyledDropdown = styled(Dropdown)`
  select {
    width: 100%;
    max-width: 550px;
  }
`;
